import { Page } from '@react-pdf/renderer';
import React from 'react';
import PageA4Style from './PageA4.style';

function PageA4(props) {
  const { children, debug = false, style = {} } = props;
  const perStyle = {
    ...style,
  };

  return (
    <Page
      size="A4"
      style={{ ...PageA4Style.container, ...perStyle }}
      debug={debug}
    >
      {children}
    </Page>
  );
}

export default PageA4;
